import { useInfiniteQuery } from '@tanstack/react-query';

import { apiGet } from '@/lib/http/client';
import {
  orgSnowflakeRequestsUrl,
  portfolioQueryKeys,
} from '@/lib/portfolio/api';
import type { SnowflakeRequestsPage } from '@/lib/portfolio/snowflake-types';

/**
 * Lists an org's Snowflake connection requests. The endpoint is DRF-paginated
 * (page_size 20), so this is an infinite query that follows the envelope's
 * `next` link — callers flatten `data.pages` and render a "Load more" control
 * off `hasNextPage`, making the full request history reachable rather than
 * silently truncating to the first page.
 */
export function useOrgSnowflakeRequests(orgId: number) {
  return useInfiniteQuery<SnowflakeRequestsPage>({
    queryKey: portfolioQueryKeys.orgSnowflakeRequests(orgId),
    queryFn: ({ pageParam }) =>
      apiGet<SnowflakeRequestsPage>(
        `${orgSnowflakeRequestsUrl(orgId)}?page=${pageParam as number}`
      ),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) =>
      lastPage.next ? allPages.length + 1 : undefined,
    enabled: !!orgId,
  });
}
